<template>
  <b-row>
    <b-col>
      <p class="text-small">
        <span class="text-danger">*</span>
        {{ text }}
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/hints/ExplicitHint.vue